

// src/pages/FlightTracker.js
// Route is /flight-tracker, but this page is used as "Case Results"
import React, { useMemo, useState } from "react";
import "./FlightTracker.css";

const RESULTS = [
  {
    id: "cr-001",
    amount: 425000,
    category: "Motorcycle Accident",
    location: "Riverside County, CA",
    title: "Motorcycle Collision — Fracture & Surgical Care",
    summary:
      "Serious injury with extended recovery. Matter resolved after early evidence preservation and a clear damages presentation.",
    notes: ["Liability developed", "Medical timeline organized", "Damages documented"],
    dateLabel: "Resolved",
  },
  {
    id: "cr-001a",
    amount: 1200000,
    category: "Car Accident",
    location: "California",
    title: "Car vs. Car — Major Settlement Recovery",
    summary:
      "High-value motor vehicle matter resolved after building a strong liability presentation, organizing treatment documentation, and clearly presenting damages.",
    notes: ["Liability developed", "Medical records organized", "Damages presentation"],
    dateLabel: "Resolved",
  },
  {
    id: "cr-001b",
    amount: 100000,
    category: "Pedestrian Accident",
    location: "California",
    title: "Pedestrian vs. Car — Injury Claim Resolution",
    summary:
      "Matter resolved through careful documentation of the incident, injury course, and recovery impact.",
    notes: ["Incident documented", "Treatment timeline", "Recovery impact"],
    dateLabel: "Resolved",
  },
  {
    id: "cr-001c",
    amount: 175000,
    category: "Car Accident",
    location: "California",
    title: "Car vs. Car — Injury Settlement",
    summary:
      "Settlement achieved after organizing records, clarifying fault, and presenting a consistent damages narrative.",
    notes: ["Fault clarified", "Records compiled", "Damages narrative"],
    dateLabel: "Resolved",
  },
  {
    id: "cr-001d",
    amount: 100000,
    category: "Car Accident",
    location: "California",
    title: "Passenger vs. Car — Injury Recovery",
    summary:
      "Passenger injury matter resolved after documenting the collision circumstances, medical care, and claim support.",
    notes: ["Passenger claim support", "Care documented", "Resolution"],
    dateLabel: "Resolved",
  },
  {
    id: "cr-001e",
    amount: 100000,
    category: "Slip & Fall",
    location: "California",
    title: "Slip and Fall — Premises Liability Recovery",
    summary:
      "Recovery obtained through condition evidence, notice analysis, and organized damages support.",
    notes: ["Condition evidence", "Notice analysis", "Damages support"],
    dateLabel: "Resolved",
  },
  {
    id: "cr-001f",
    amount: 800000,
    category: "Government Claim",
    location: "California",
    title: "Car vs. County — Government Claim Resolution",
    summary:
      "Substantial recovery secured after developing a strong factual record, preserving key evidence, and presenting damages clearly.",
    notes: ["Evidence preserved", "Government claim handling", "Damages documented"],
    dateLabel: "Resolved",
  },
  {
    id: "cr-001g",
    amount: 100000,
    category: "Motorcycle Accident",
    location: "California",
    title: "Motorcycle Accident — Injury Settlement",
    summary:
      "Matter resolved through liability proof, treatment documentation, and a focused damages presentation.",
    notes: ["Liability proof", "Treatment records", "Settlement"],
    dateLabel: "Resolved",
  },
  {
    id: "cr-001h",
    amount: 100000,
    category: "Truck Accident",
    location: "California",
    title: "Truck Accident — Injury Claim Resolution",
    summary:
      "Recovery achieved after organizing collision facts, care records, and overall claim support.",
    notes: ["Collision facts", "Care records", "Claim support"],
    dateLabel: "Resolved",
  },
  {
    id: "cr-001i",
    amount: 90000,
    category: "Civil Rights",
    location: "California",
    title: "Civil Case vs. City — Claim Recovery",
    summary:
      "Matter resolved after organizing the factual timeline, supporting records, and damages presentation.",
    notes: ["Timeline organized", "Supporting records", "Damages presentation"],
    dateLabel: "Resolved",
  },
  {
    id: "cr-001j",
    amount: 100000,
    category: "Car Accident",
    location: "California",
    title: "Car vs. Car — Documented Injury Recovery",
    summary:
      "Settlement reflected clear liability analysis, treatment support, and organized claim presentation.",
    notes: ["Liability analysis", "Treatment support", "Claim presentation"],
    dateLabel: "Resolved",
  },
  {
    id: "cr-002",
    amount: 310000,
    category: "Car Accident",
    location: "San Bernardino County, CA",
    title: "Rear-End — Concussion Symptoms & Treatment",
    summary:
      "Settlement reflected consistent symptom documentation, treatment progression, and clear causation.",
    notes: ["Records collected", "Treatment narrative", "Claim strategy"],
    dateLabel: "Resolved",
  },
  {
    id: "cr-003",
    amount: 240000,
    category: "Car Accident",
    location: "San Bernardino County, CA",
    title: "T-Bone Intersection Crash — ER Visit & Rehab",
    summary:
      "Recovery secured after organizing incident records, witness details, and a well-supported demand package.",
    notes: ["Witness support", "Dispute handled", "Negotiation"],
    dateLabel: "Resolved",
  },
  {
    id: "cr-004",
    amount: 215000,
    category: "Motorcycle Accident",
    location: "San Bernardino, CA",
    title: "Unsafe Lane Change — Road Rash & Wrist Injury",
    summary:
      "Resolution achieved through liability proof and consistent care documentation.",
    notes: ["Liability proof", "Treatment consistency", "Outcome"],
    dateLabel: "Resolved",
  },
  {
    id: "cr-005",
    amount: 200000,
    category: "Rideshare",
    location: "Inland Empire, CA",
    title: "Rideshare Passenger Injury — Multiple Policies",
    summary:
      "Matter involved clarifying coverage layers and coordinating claim presentation across policies.",
    notes: ["Coverage layers", "Coordination", "Resolution"],
    dateLabel: "Resolved",
  },
  {
    id: "cr-006",
    amount: 185000,
    category: "Car Accident",
    location: "Redlands, CA",
    title: "Rear-End Collision — Cervical & Lumbar Injury",
    summary:
      "Settlement achieved after presenting a clean medical timeline and clear liability evidence.",
    notes: ["Medical timeline", "Liability", "Settlement"],
    dateLabel: "Resolved",
  },
  {
    id: "cr-007",
    amount: 165000,
    category: "Rideshare",
    location: "San Bernardino County, CA",
    title: "Rideshare Passenger — Rear-End While in Transit",
    summary:
      "Case emphasized documentation, causation, and policy coordination.",
    notes: ["Documentation", "Causation", "Coordination"],
    dateLabel: "Resolved",
  },
  {
    id: "cr-008",
    amount: 160000,
    category: "Car Accident",
    location: "Redlands, CA",
    title: "Left-Turn Crash — Shoulder Injury",
    summary:
      "Outcome supported by right-of-way evidence and a strong treatment narrative.",
    notes: ["Right-of-way", "Care narrative", "Outcome"],
    dateLabel: "Resolved",
  },
  {
    id: "cr-009",
    amount: 145000,
    category: "Rideshare",
    location: "Riverside County, CA",
    title: "Rideshare Driver Hit — Coverage Coordination",
    summary:
      "Matter involved policy sequencing and damage support.",
    notes: ["Sequencing", "Damage support", "Resolution"],
    dateLabel: "Resolved",
  },
  {
    id: "cr-010",
    amount: 130000,
    category: "Slip & Fall",
    location: "Inland Empire, CA",
    title: "Slip & Fall — Store Aisle Hazard",
    summary:
      "Resolution achieved by focusing on notice, condition evidence, and damages documentation.",
    notes: ["Notice", "Condition evidence", "Damages"],
    dateLabel: "Resolved",
  },
  {
    id: "cr-011",
    amount: 120000,
    category: "Slip & Fall",
    location: "San Bernardino County, CA",
    title: "Slip & Fall — Wet Surface Without Warning",
    summary:
      "Recovery achieved after documenting the condition, notice, and treatment impact.",
    notes: ["Condition", "Notice", "Impact"],
    dateLabel: "Resolved",
  },
  {
    id: "cr-012",
    amount: 110000,
    category: "Slip & Fall",
    location: "Redlands, CA",
    title: "Slip & Fall — Hazardous Floor Condition",
    summary:
      "Matter resolved after investigating the premises and connecting the hazard to the injury and care.",
    notes: ["Premises review", "Causation", "Resolution"],
    dateLabel: "Resolved",
  },
  {
    id: "cr-013",
    amount: 98000,
    category: "Car Accident",
    location: "Redlands, CA",
    title: "Rear-End — Shoulder Strain & Physical Therapy",
    summary:
      "Conservative treatment case resolved with organized records and clear liability.",
    notes: ["Organized records", "Clear liability", "Result"],
    dateLabel: "Resolved",
  },
  {
    id: "cr-014",
    amount: 95000,
    category: "Car Accident",
    location: "I-10 Corridor, CA",
    title: "Multi-Vehicle Freeway Crash — Soft Tissue & PT",
    summary:
      "Chain-reaction crash with multiple involved drivers. Matter resolved after organizing the facts and records.",
    notes: ["Multi-party", "Fact pattern", "Organization"],
    dateLabel: "Resolved",
  },
  {
    id: "cr-015",
    amount: 75000,
    category: "Slip & Fall",
    location: "Redlands, CA",
    title: "Trip Hazard — Uneven Surface Fall",
    summary:
      "Resolved after investigating property conditions and documenting injury impact.",
    notes: ["Property conditions", "Documentation", "Resolution"],
    dateLabel: "Resolved",
  },
];

const CATEGORIES = ["All", "Car Accident", "Motorcycle Accident", "Slip & Fall", "Rideshare", "Pedestrian Accident", "Government Claim", "Truck Accident", "Civil Rights"];

function money(n) {
  try {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 0,
    }).format(n);
  } catch {
    return `$${n}`;
  }
}

export default function FlightTracker() {
  const [query, setQuery] = useState("");
  const [category, setCategory] = useState("All");
  const [sortBy, setSortBy] = useState("Highest");
  const [openId, setOpenId] = useState(RESULTS[0]?.id || "");

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    const base = RESULTS.filter((r) => {
      const matchesCat = category === "All" ? true : r.category === category;
      const hay = `${r.title} ${r.category} ${r.location} ${r.summary}`.toLowerCase();
      const matchesQ = !q ? true : hay.includes(q);
      return matchesCat && matchesQ;
    });

    const sorted = [...base].sort((a, b) => {
      if (sortBy === "Lowest") return a.amount - b.amount;
      if (sortBy === "Newest") return b.id.localeCompare(a.id);
      return b.amount - a.amount;
    });

    return sorted;
  }, [query, category, sortBy]);

  const total = useMemo(() => filtered.reduce((sum, r) => sum + r.amount, 0), [filtered]);
  const avg = filtered.length ? Math.round(total / filtered.length) : 0;
  const top = filtered[0];

  return (
    <div className="crx">
      <header className="crxHero" aria-label="Case Results header">
        <div className="crxHeroInner">
          <div className="crxHeroTop">
            <div>
              <p className="crxKicker">Edgar Lopez Law</p>
              <h1 className="crxTitle">Case Results</h1>
              <p className="crxSub">
                A sample of resolved personal injury matters. <strong>Past results do not guarantee future outcomes</strong>.
              </p>
            </div>

            <div className="crxStats" aria-label="Case results summary statistics">
              <div className="crxStat">
                <div className="crxStatLabel">Results shown</div>
                <div className="crxStatValue">{filtered.length}</div>
              </div>
              <div className="crxStat">
                <div className="crxStatLabel">Avg. recovery</div>
                <div className="crxStatValue">{avg ? money(avg) : "—"}</div>
              </div>
              <div className="crxStat">
                <div className="crxStatLabel">Top result</div>
                <div className="crxStatValue">{top ? money(top.amount) : "—"}</div>
              </div>
            </div>
          </div>

          <div className="crxControls" role="search">
            <label className="sr-only" htmlFor="crxSearch">Search case results</label>
            <input
              id="crxSearch"
              className="crxInput"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Search (rear-end, rideshare, slip, Redlands)…"
              aria-label="Search case results"
            />

            <label className="sr-only" htmlFor="crxCat">Filter by category</label>
            <select
              id="crxCat"
              className="crxSelect"
              value={category}
              onChange={(e) => setCategory(e.target.value)}
              aria-label="Filter by category"
            >
              {CATEGORIES.map((c) => (
                <option key={c} value={c}>{c}</option>
              ))}
            </select>

            <label className="sr-only" htmlFor="crxSort">Sort results</label>
            <select
              id="crxSort"
              className="crxSelect"
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
              aria-label="Sort results"
            >
              <option value="Highest">Highest</option>
              <option value="Lowest">Lowest</option>
              <option value="Newest">Newest</option>
            </select>
          </div>

          <div className="crxNote">
            These examples are for informational purposes only and do not create an attorney-client relationship.
          </div>
        </div>
      </header>

      <main className="crxMain">
        {top && (
          <section className="crxFeatured" aria-label="Featured case result">
            <div className="crxFeaturedInner">
              <div className="crxFeaturedBadge">Featured</div>
              <div className="crxFeaturedGrid">
                <div>
                  <h2 className="crxFeaturedTitle">{top.title}</h2>
                  <div className="crxPills">
                    <span className="crxPill">{top.category}</span>
                    <span className="crxPill">{top.location}</span>
                    <span className="crxPill">{top.dateLabel}</span>
                  </div>
                  <p className="crxFeaturedText">{top.summary}</p>
                </div>
                <div className="crxFeaturedAmount" aria-label="Featured amount">
                  <div className="crxFeaturedAmountLabel">Recovery</div>
                  <div className="crxFeaturedAmountValue">{money(top.amount)}</div>
                  <div className="crxFeaturedAmountHint">Amounts and outcomes vary by case.</div>
                </div>
              </div>
            </div>
          </section>
        )}

        <section className="crxList" aria-label="Case results">
          <div className="crxTimeline">
            {filtered.map((r, idx) => {
              const isOpen = openId === r.id;
              return (
                <article key={r.id} className={`crxCard ${isOpen ? "isOpen" : ""}`}>
                  <div className="crxDot" aria-hidden="true" />
                  <button
                    type="button"
                    className="crxCardHeader"
                    onClick={() => setOpenId((cur) => (cur === r.id ? "" : r.id))}
                    aria-expanded={isOpen}
                  >
                    <div className="crxCardLeft">
                      <div className="crxCardCat">{r.category}</div>
                      <h3 className="crxCardTitle">{r.title}</h3>
                      <div className="crxCardMeta">{r.location} • {r.dateLabel}</div>
                    </div>
                    <div className="crxCardRight">
                      <div className="crxCardAmount">{money(r.amount)}</div>
                      <div className="crxChevron" aria-hidden="true" />
                    </div>
                  </button>

                  <div className="crxCardBody" style={{ maxHeight: isOpen ? 260 : 0 }}>
                    <div className="crxCardBodyInner">
                      <p className="crxCardSummary">{r.summary}</p>
                      <ul className="crxBullets">
                        {r.notes.map((n) => (
                          <li key={n}>{n}</li>
                        ))}
                      </ul>
                      <p className="crxFinePrint">Past results do not guarantee future outcomes. Each case is unique.</p>
                    </div>
                  </div>

                  <style>{`.crxCard:nth-child(${idx + 1}){animation-delay:${Math.min(idx * 55, 520)}ms}`}</style>
                </article>
              );
            })}

            {filtered.length === 0 && (
              <div className="crxEmpty" role="status">No results found. Try another keyword or category.</div>
            )}
          </div>
        </section>

        <section className="crxCTA" aria-label="Free consultation">
          <div className="crxCTAInner">
            <h2>Request a Free Consultation</h2>
            <p>If you were injured, you may be entitled to compensation. Share a few details and we’ll review your situation.</p>
            <div className="crxCTAActions">
              <a className="crxBtn" href="/quote">Get Started</a>
              <a className="crxBtn ghost" href="/contactus">Contact Us</a>
            </div>
            <div className="crxDisclaimer">Submitting a request does not create an attorney-client relationship.</div>
          </div>
        </section>

        <footer className="crxFooter">
          <a href="/privacy">Privacy Policy</a>
          <span className="crxSep">•</span>
          <a href="/terms">Terms &amp; Conditions</a>
        </footer>
      </main>
    </div>
  );
}